export const stats: [string, string][] = [
  ['10', 'TOMES'],
  ['600', 'PAGES HORS BONUS'],
  ['5', 'BONUS INCLUS'],
  ['100\u00A0%', 'EN FRANÇAIS'],
]
